import api from "@/services/api";

let cached;

export const getAppConfig = () => {
  if (!cached) {
    cached = api
      .get("/config")
      .then((r) => r.data)
      .catch(() => ({ onchain_escrow_enabled: false }));
  }
  return cached;
};
